import { getCurrentUserId } from "@utils/userUtils";

export const DEFAULT_FACILITIES_DRAWER_WIDTH = 240;
export const MIN_FACILITIES_DRAWER_WIDTH = 200;
export const MAX_FACILITIES_DRAWER_WIDTH = 560;

const STORAGE_KEY_PREFIX = "unicomply_facilities_drawer_width";

export function getFacilitiesDrawerWidthStorageKey(userId?: string | null): string {
  const id = userId ?? getCurrentUserId();
  return id ? `${STORAGE_KEY_PREFIX}_${id}` : STORAGE_KEY_PREFIX;
}

export function clampFacilitiesDrawerWidth(width: number): number {
  return Math.min(MAX_FACILITIES_DRAWER_WIDTH, Math.max(MIN_FACILITIES_DRAWER_WIDTH, width));
}

export function readFacilitiesDrawerWidth(userId?: string | null): number {
  try {
    const raw = localStorage.getItem(getFacilitiesDrawerWidthStorageKey(userId));
    if (!raw) return DEFAULT_FACILITIES_DRAWER_WIDTH;
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed)) return DEFAULT_FACILITIES_DRAWER_WIDTH;
    return clampFacilitiesDrawerWidth(parsed);
  } catch {
    return DEFAULT_FACILITIES_DRAWER_WIDTH;
  }
}

export function writeFacilitiesDrawerWidth(width: number, userId?: string | null): void {
  try {
    localStorage.setItem(
      getFacilitiesDrawerWidthStorageKey(userId),
      String(clampFacilitiesDrawerWidth(width)),
    );
  } catch {
    // Ignore quota or privacy-mode storage failures.
  }
}
